import { Comparable, ExportJobId, ExportStatus, FragmentId, IExportJob, Trackable } from '@stylehaven/components';
export class ExportJob implements IExportJob, Comparable, Trackable {
    readonly ExportJobId: ExportJobId;
    readonly Name: string;
    readonly RecordId: FragmentId;
    readonly Status: ExportStatus;
    readonly Progress: number;
    readonly DownloadUrl: string;
    readonly CreationDate: string;
    readonly StartDate: string;
    readonly FinishDate: string;
    readonly ExpiryDate: string;

    constructor(exportJob: IExportJob) {
        this.ExportJobId = exportJob.ExportJobId;
        this.Name = exportJob.Name;
        this.RecordId = exportJob.RecordId;
        this.Status = exportJob.Status;
        this.Progress = exportJob.Progress;
        this.DownloadUrl = exportJob.DownloadUrl;
        this.CreationDate = exportJob.CreationDate;
        this.StartDate = exportJob.StartDate;
        this.FinishDate = exportJob.FinishDate;
        this.ExpiryDate = exportJob.ExpiryDate;
    }

    equals(other: any): boolean {
        if (!(other instanceof ExportJob)) {
            return false;
        }
        return this.ExportJobId === other.ExportJobId;
    }

    trackBy(): string {
        return this.ExportJobId;
    }
}
